import {api} from './api';
import {isAxiosError} from 'axios';

const API_BASE_URL = '/api/v1/agents/debug';

export interface AgentDebugExecuteRequest {
    agentConfigId: number;
    triggerKind: 'EVENT' | 'MESSAGE';
    eventType: string;
    payloadJson: string;
    userId?: number;
    apiKeyId?: number;
    sideEffectMode?: string;
    skipStartingGun?: boolean;
    startingGunToolsJson?: string;
    replaySourceKind?: string;
    replaySourceId?: string;
    triggerCode?: string;
}

export interface AgentDebugExecuteResponse {
    recordId: number;
    traceId: string;
    status: string;
    message: string;
}

export interface FlowNodeStatus {
    nodeCode: string;
    nodeName: string;
    orderNo: number;
    status: string;
    startTime?: number;
    endTime?: number;
    durationMs?: number;
    message?: string;
}

export interface AgentDebugDetailResponse {
    id: number;
    agentConfigId: number;
    agentName: string;
    triggerKind: string;
    eventType: string;
    payloadJson: string;
    traceId: string;
    status: string;
    resultSummary: string;
    nodeCount: number;
    totalTimeMs: number;
    userId: number;
    flowNodes: FlowNodeStatus[];
    createdAt: string;
    updatedAt: string;
}

export interface AgentDebugRecord {
    id: number;
    agentConfigId: number;
    agentName: string;
    triggerKind: string;
    eventType: string;
    payloadJson: string;
    traceId: string;
    executionId?: string;
    sideEffectMode?: string;
    replaySourceKind?: string;
    replaySourceId?: string;
    status: string;
    resultSummary: string;
    nodeCount: number;
    totalTimeMs: number;
    userId: number;
    createdAt: string;
    updatedAt: string;
}

class AgentDebugService {
    async executeDebug(request: AgentDebugExecuteRequest): Promise<AgentDebugExecuteResponse> {
        try {
            const response = await api.post(`${API_BASE_URL}/execute`, request);
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '调试执行失败');
            }
            throw error;
        }
    }

    async getHistory(agentConfigId: number, limit?: number): Promise<AgentDebugRecord[]> {
        try {
            const params: any = {agentConfigId};
            if (limit) params.limit = limit;
            const response = await api.get(`${API_BASE_URL}/history`, {params});
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '获取调试历史失败');
            }
            throw error;
        }
    }

    async getDetail(id: number): Promise<AgentDebugDetailResponse> {
        try {
            const response = await api.get(`${API_BASE_URL}/history/${id}`);
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '获取调试详情失败');
            }
            throw error;
        }
    }

    async replayDebug(id: number): Promise<AgentDebugExecuteResponse> {
        try {
            const response = await api.post(`${API_BASE_URL}/history/${id}/replay`);
            return response.data.data;
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.message || '重放调试失败');
            }
            throw error;
        }
    }
}

export const agentDebugService = new AgentDebugService();
